<template>
  <div class="columns-setting-wrapper">
    <!-- setting header -->
    <div class="columns-setting-header">
      <span class="column-name column-first">表头名称</span>
      <span class="column-fixed">锁定列</span>
      <span class="column-hidden">是否显示</span>
    </div>

    <!-- setting content -->
    <draggable :list="list" class="draggable-content" @end="changeColumns">
      <div v-for="(item, index) in list" :key="index" class="draggable-item">
        <div class="draggable-item-unit column-name ellipsis-warp">
          <svg-icon icon-class="move"></svg-icon>
          <el-tooltip class="item" effect="dark" :content="item.label" placement="top">
            <span class="column-label">{{ item.label }}</span>
          </el-tooltip>
        </div>
        <div class="draggable-item-unit column-fixed column-fixed-svg">
          <svg-icon
            :icon-class="columnFixed(item, 'left')"
            @click="handleFixedColumn(item, 'left')"
          ></svg-icon>
          <svg-icon
            :icon-class="columnFixed(item, 'right')"
            @click="handleFixedColumn(item, 'right')"
          ></svg-icon>
        </div>
        <div class="draggable-item-unit column-hidden">
          <el-checkbox
            v-model="item.checked"
            :disabled="item.disabled || (list.length < 2 && item.checked)"
            @change="toggleColumnHidden(item)"
          />
          <span class="column-hidden-label">显示</span>
        </div>
      </div>
    </draggable>

    <!-- setting footer -->
    <div class="columns-setting-footer">
      <el-button plain @click="resetColumns">恢复默认</el-button>
      <el-button type="primary" size="mini" @click="applyColumns">应用</el-button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { cloneDeep, isEqual } from "lodash";
import ColumnApi from "@/api/general-table";

export default {
  name: "RcTableSetting",
  components: { draggable },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    code: [String, Number],
    version: [String, Number]
  },
  data() {
    return {
      list: []
    };
  },
  computed: {
    columnFixed() {
      return (item, direction) => {
        if (direction === "left") {
          if (item.fixed === true || item.fixed === "true" || item.fixed === "left") {
            return "locked_left";
          }

          return "unlock_left";
        }

        if (item.fixed === "right") {
          return "locked_right";
        }

        return "unlock_right";
      };
    }
  },
  watch: {
    columns: {
      deep: true,
      immediate: true,
      handler(newValue) {
        // 生成虚拟属性checked
        newValue = newValue.map(item => {
          item.checked = !item.hidden;
          return item;
        });

        if (isEqual(newValue, this.list)) {
          return;
        }

        this.list = cloneDeep(newValue);
      }
    }
  },
  methods: {
    // 修改columns
    changeColumns() {
      // 拖拽后的列变更
      this.$emit("changeColumns", this.list);
    },
    // 切换隐藏
    toggleColumnHidden(item) {
      item.hidden = !item.hidden;
      this.changeColumns();
    },
    // 修改左右固定
    handleFixedColumn(item, direction = "left") {
      item.fixed = item.fixed === direction ? false : direction;
      this.changeColumns();
    },
    // 重置
    resetColumns() {
      this.$emit("resetColumns");
    },
    // 应用
    applyColumns() {
      this.$emit("applyColumns", this.list);
      const columnList = this.list.map(col => ({
        displayName: col.label,
        name: col.key,
        fixed: col.fixed,
        hidden: col.hidden,
        sortable: col.sortable,
        width: col.width
      }));
      ColumnApi.saveFormColumn(this.code, {
        columnShow: columnList,
        formVersion: this.version
      }).then(res => {
        // 保存成功
      });
    }
  }
};
</script>
